import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { BarChart2, TrendingUp, TrendingDown, Minus } from 'lucide-react';
const ipoleksosbudhankam = [{
  name: 'IDEOLOGI',
  score: 82,
  status: 'STABIL',
  color: 'bg-emerald-500',
  trend: 'flat'
}, {
  name: 'POLITIK',
  score: 65,
  status: 'WASPADA',
  color: 'bg-amber-500',
  trend: 'down'
}, {
  name: 'EKONOMI',
  score: 45,
  status: 'KRITIS',
  color: 'bg-red-500',
  trend: 'down'
}, {
  name: 'SOSIAL',
  score: 58,
  status: 'KRITIS',
  color: 'bg-red-500',
  trend: 'down'
}, {
  name: 'BUDAYA',
  score: 88,
  status: 'STABIL',
  color: 'bg-emerald-500',
  trend: 'up'
}, {
  name: 'PERTAHANAN',
  score: 90,
  status: 'STABIL',
  color: 'bg-emerald-500',
  trend: 'flat'
}, {
  name: 'KEAMANAN',
  score: 72,
  status: 'WASPADA',
  color: 'bg-amber-500',
  trend: 'up'
}];
const astagatra = [{
  name: 'GEOGRAFI',
  score: 75
}, {
  name: 'DEMOGRAFI',
  score: 68
}, {
  name: 'SUMBER DAYA',
  score: 52
}];
export function IpoleksosbudhankamPanel() {
  return <Card className="bg-card border-border/50 h-full flex flex-col" data-id="element-446">
      <CardHeader className="pb-2 pt-4 px-4 border-b border-border/50" data-id="element-447">
        <CardTitle className="font-mono text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-2" data-id="element-448">
          <BarChart2 className="size-4" data-id="element-449" />
          IPOLEKSOSBUDHANKAM Digital Stability
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 flex-1 flex flex-col justify-between" data-id="element-450">
        <div className="flex flex-col gap-3" data-id="element-451">
          {ipoleksosbudhankam.map(item => <div key={item.name} className="flex items-center gap-3" data-id="element-452">
              <div className="w-24 font-mono text-[10px] text-muted-foreground" data-id="element-453">
                {item.name}
              </div>
              <div className="w-6 font-mono text-[10px] text-right font-bold" data-id="element-454">
                {item.score}
              </div>
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden" data-id="element-455">
                <div className={`h-full ${item.color}`} style={{
              width: `${item.score}%`
            }} data-id="element-456" />
              </div>
              <div className={`w-16 font-mono text-[9px] text-center py-0.5 rounded border ${item.status === 'STABIL' ? 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20' : item.status === 'WASPADA' ? 'bg-amber-500/10 text-amber-500 border-amber-500/20' : 'bg-red-500/10 text-red-500 border-red-500/20'}`} data-id="element-457">
                {item.status}
              </div>
              <div className="w-4" data-id="element-458">
                {item.trend === 'up' ? <TrendingUp className="size-3 text-emerald-500" data-id="element-459" /> : item.trend === 'down' ? <TrendingDown className="size-3 text-red-500" data-id="element-460" /> : <Minus className="size-3 text-muted-foreground" data-id="element-461" />}
              </div>
            </div>)}
        </div>

        <div className="mt-6 pt-4 border-t border-border/50" data-id="element-462">
          <div className="flex items-center justify-between mb-3" data-id="element-463">
            <span className="font-mono text-[10px] text-muted-foreground" data-id="element-464">
              ASTAGATRA (TRIGATRA)
            </span>
            <div className="flex gap-2" data-id="element-465">
              {astagatra.map(item => <div key={item.name} className="flex items-center gap-1 bg-muted/30 px-2 py-1 rounded border border-border/50" data-id="element-466">
                  <span className="font-mono text-[8px] text-muted-foreground" data-id="element-467">
                    {item.name}:
                  </span>
                  <span className={`font-mono text-[9px] font-bold ${item.score < 60 ? 'text-red-500' : 'text-amber-500'}`} data-id="element-468">
                    {item.score}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="bg-amber-500/10 border border-amber-500/30 rounded-md p-3 flex items-center justify-between" data-id="element-469">
            <span className="font-mono text-xs text-amber-500/70" data-id="element-470">
              NATIONAL STABILITY COMPOSITE
            </span>
            <div className="flex items-center gap-3" data-id="element-471">
              <span className="font-heading text-2xl font-bold text-amber-500" data-id="element-472">
                68<span className="text-sm text-amber-500/50" data-id="element-473">/100</span>
              </span>
              <span className="font-mono text-xs font-bold bg-amber-500 text-background px-2 py-1 rounded" data-id="element-474">
                WASPADA
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
}